import { IconCloseMapWindow, IconMap } from 'components/icon/Icon';

import s from './MapInfoWindow.module.scss';
import { Charging_StationCharginglist } from 'prismic-types';
import { useEffect, useRef } from 'react';

type Props = {
  address?: JSX.Element;
  chargingList?: Charging_StationCharginglist[] | null;
  description?: string;
  title?: string;
  closeInfoWindow: () => void;
};

export const MapInfoWindow = ({
  address,
  chargingList,
  description,
  title,
  closeInfoWindow,
}: Props) => {
  const popoverRef = useRef<HTMLDivElement>(null);
  const closeIconRef = useRef<HTMLDivElement>(null);

  const mouseDownPos = useRef<{ x: number; y: number }>({ x: 0, y: 0 });

  const handleMouseDown = (event: MouseEvent) => {
    mouseDownPos.current = { x: event.clientX, y: event.clientY };
  };

  const handleMouseUp = (event: MouseEvent) => {
    const { x, y } = mouseDownPos.current;
    const distance = Math.hypot(event.clientX - x, event.clientY - y);
    const threshold = 5;

    const isDragging = distance >= threshold;

    if (isDragging) return;

    if (
      (popoverRef.current &&
        !popoverRef.current.contains(event.target as Node)) ||
      (closeIconRef.current &&
        closeIconRef.current.contains(event.target as Node))
    ) {
      closeInfoWindow();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={s.container} ref={popoverRef}>
      <div className={s.header}>
        {title && <h1 className={s.title}>{title}</h1>}
        <div className={s.closeIcon} ref={closeIconRef}>
          <IconCloseMapWindow />
        </div>
      </div>
      <div className={s.linkContainer}>
        <div className={s.links}>
          {address && address}
          {description && <p className={s.description}>{description}</p>}
        </div>
        <div className={s.iconContainer}>
          <div style={{ width: 12 }}>
            <IconMap />
          </div>
        </div>
      </div>
      <hr className={s.divider} />
      {chargingList && (
        <dl>
          {chargingList.map((item) => (
            <>
              <dt>{item.label}</dt>
              <dd>{item.value}</dd>
            </>
          ))}
        </dl>
      )}
    </div>
  );
};
